import { render, staticRenderFns } from "./Table_fixed.vue?vue&type=template&id=732afc6d&scoped=true"
import script from "./Table_fixed.vue?vue&type=script&lang=js"
export * from "./Table_fixed.vue?vue&type=script&lang=js"
import style0 from "./Table_fixed.vue?vue&type=style&index=0&id=732afc6d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732afc6d",
  null
  
)

export default component.exports